module.exports = __webpack_public_path__ + "assets/img/budapark5-1280.8721c99f.webp";